import { Component, ElementRef, OnDestroy, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AuthService } from "../../services/auth.service";
import { Content, NavController, NavParams } from "ionic-angular";
import { LoginRequired } from "../../decorators/login.required";
import { ApiService } from "../../services/api.service";
import { Post, PostReaction, ViewDidEnter, ViewDidLeave } from "../../app/app.interfaces";
import { PageTitleService } from "../../services/page-title.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { EventService } from "../../services/event.service";
import { ReactionCard } from "../../partials/reaction/reaction-card/reaction-card";
import { ReactionCreate } from "../../partials/reaction/reaction-create/reaction-create";
import { PostService } from "../../services/post.service";
import { filter, tap } from "rxjs/operators";
import { Subscription } from "rxjs";


@LoginRequired()
@Component({
  selector: 'single-post',
  templateUrl: 'single-post.html'
})
export class SinglePost implements ViewDidEnter, ViewDidLeave {

  post?: Post;
  highlightReactionId?: any = null;
  edit: boolean = false;
  showReactionCreate: boolean = false;
  reportCreate: boolean = false;  
  hideSpinner: boolean = false;
  
  headerBarMobileTemplate = 'back';
  headerBarMobileTitle = 'post';

  sortedReactions: PostReaction[] = [];

  subscriptions: Subscription[] = [];
  
  @ViewChild(ReactionCreate, { read: ElementRef }) reactionCreate: ElementRef;
  @ViewChild(Content) container: Content;
	@ViewChildren(ReactionCard) reactionCards: QueryList<ReactionCard>;

  constructor(public authService: AuthService,
              private navParams: NavParams,
              private nav: NavController,
              private apiService: ApiService,
              private pageTitleService: PageTitleService,
              private ionic: IonicHelper,
							private eventService: EventService
  ) {
  }

  postEdit(post?:Post){
    if(post){
      this.post = post;    
    }
    this.edit = false;
  }

  reactionPlaced(newReaction: PostReaction){
  	if(newReaction) {
      this.post.reactions.push(newReaction);
			this.post.reactionsCount++;
			
			setTimeout(() => {
        this.reactionCards.forEach((reactionCard) => {
          if (reactionCard.postReaction.id == newReaction.id) {            
            reactionCard.setHighlight(true);            
            this.ionic.scrollElementIntoView(reactionCard.elementRef, this.container);                
          }
        });			  
      },50);			
		}
		this.toggleReactionCreate(false);
	}
  
  
  ionViewDidEnter(){
    
    this.headerBarMobileTemplate = 'back';
		

		this.eventService.closeReactionCard.subscribe((close) => {
			this.toggleReactionCreate(!close);
		});

    let postId = this.navParams.get('postId');
    if(postId){
      postId = parseInt(postId, 10);
      if(typeof postId === 'string' && postId.indexOf(';')!==-1){
        let postIdComponents = postId.split(';');
        postId = postIdComponents[0];
        this.highlightReactionId = postIdComponents[1];
      }

			this.loadPost(postId).then(() => {
			  setTimeout(()=> {
			    
			    if(this.highlightReactionId == 'beantwoorden') {
			      this.toggleReactionCreate(true);
          }
          else {

            if (this.reactionCards.length) {

              this.reactionCards.forEach((reactionCard) => {
                if (reactionCard.postReaction.id == this.highlightReactionId) {
                  reactionCard.setHighlight(true);
                  
                  this.ionic.scrollElementIntoView(reactionCard.elementRef, this.container);
                }
              });
            }
          }
			      
        },150)
      });

      this.initBestReactionSubscriptions();



    }


  }

  ionViewDidLeave(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  initBestReactionSubscriptions() {

    const showLoader = () => { this.ionic.toggleLoader(true); };
    const reloadPostHideLoaderShowToast = (set: boolean) => {
      this.loadPost(this.post.id).then(() => {
        this.ionic.toggleLoader(false);
        this.ionic.toast(set ? 'REACTION.SET_AS_BEST_TOAST' : 'REACTION.UNSET_AS_BEST_TOAST');
      });
    };

    const spbSub = this.eventService.setPostBestReaction.subscribe(showLoader);
    this.subscriptions.push(spbSub);

    const upbSub = this.eventService.unsetPostBestReaction.subscribe(showLoader);
    this.subscriptions.push(upbSub);

    const pbrSub = this.eventService.postBestReactionSet.pipe(
      filter(({post}) => post.id===this.post.id)
    ).subscribe(() => {
      reloadPostHideLoaderShowToast(true);
    });
    this.subscriptions.push(pbrSub);

    const ubrSub = this.eventService.unsetPostBestReaction.pipe(
      filter(({post}) => post.id===this.post.id)
    ).subscribe(() => {
      reloadPostHideLoaderShowToast(false);
    });
    this.subscriptions.push(ubrSub);

  }


  loadPost(postId): Promise<void> {
		return new Promise<void>((resolve) => {
      this.apiService.getResourceById('posts', postId).then((post: Post)=> {
        this.post = post;
        PostService.sortReactions(this.post.reactions);
        this.headerBarMobileTitle = 'post';
        this.pageTitleService.setPageTitle('post', post);
        resolve();
      }).catch((err) => {
        console.error(err);
        this.hideSpinner = true;
        this.ionic.uncoverableErrorAlert('POST_NOT_FOUND');
      });
		  
    });
	}

	toggleReactionCreate(show:boolean = true): void{
  	this.showReactionCreate = show;
		this.eventService.toggleTabBar.emit(!show);
  	if(this.showReactionCreate){
      this.headerBarMobileTemplate = 'answer';
      this.headerBarMobileTitle = 'answer';
		}
		else{
      this.headerBarMobileTemplate = 'back';
      this.headerBarMobileTitle = 'post';
			this.pageTitleService.setPageTitle('post', this.post);
		}
	}
	
	showChildReactionCreate(show: boolean){
    if(show){
      this.headerBarMobileTemplate = 'reaction';
      this.headerBarMobileTitle = 'reaction'; 
    }
    else {      
      this.headerBarMobileTemplate = 'back';
      this.headerBarMobileTitle = 'post';
			this.pageTitleService.setPageTitle('post', this.post);
    }
  }

	deletePost(){
    if(!this.post.userHasModeratingAccess) {
      throw new Error('User must have moderating access for this');
    }

    this.ionic.confirm('POST.CONFIRM_DELETE_MSG', 'GLOBAL.ARE_YOU_SURE','GLOBAL.DELETE').subscribe((confirmed: boolean) => {
      if(confirmed){
        this.apiService.deleteResource(this.post).then(()=>{
          this.ionic.toast('POST.DELETED_TOAST');
          this.nav.setRoot('dashboard');
        }).catch((err) => {
					console.error(err);    	
					this.ionic.alert('GLOBAL.GENERAL_ERROR');
				});      
      }
    });

  }
  
	setPostPublished(published: boolean){
    if(!this.authService.user.admin) {
      throw new Error('User must be admin for this');
    }
    this.apiService.updateResource(this.post, { published: published }).then((post: Post) => {
      this.post.published = published;
      this.ionic.toast(published ? 'POST.PUBLISHED_TOAST' : 'POST.UNPUBLISHED_TOAST');
    }).catch((err) => {
    	console.error(err);    	
      this.ionic.alert('GLOBAL.GENERAL_ERROR');
		});
  }

  removeReaction(postReaction: PostReaction){
    this.post.reactions = this.post.reactions.filter(e => e !== postReaction);
    //Reload posts to propagate num answers			
    this.eventService.reloadPosts.emit();	
  }

	// scrollToChildReactionCreate(element: ElementRef){
	//
	// 	let elementPosition = element.nativeElement.getBoundingClientRect();
	//
	// 	console.log(element);
	//
	// 	console.log(elementPosition);
	//
	// 	this.container.scrollTo(elementPosition.left, elementPosition.top, 200);
	//
	// }


	toggleReportCreate(open: boolean = true){
		this.reportCreate = open;
	}
					
  toggleFavourite(){   
      // this.changeDetector.detectChanges();
    if(this.post.userFavourite) {
      this.ionic.toast('POST.FAVOURITE_REMOVED');
       this.apiService.resourceCustomPut(this.post['@id'], 'favourite/remove').then((post: Post)=> {  
        this.eventService.reloadPosts.emit();	
        // this.postReaction.userHasUpvoted = postReaction.userHasUpvoted;
      }).catch((err) => {
        console.error(err);    	
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
    }
    else {
      this.ionic.toast('POST.FAVOURITE_ADDED');
       this.apiService.resourceCustomPut(this.post['@id'], 'favourite/add').then((post: Post)=> {  
        this.eventService.reloadPosts.emit();	
      }).catch((err) => {
        console.error(err);    	
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
      
    }
   
    this.post.userFavourite = !(this.post.userFavourite); 
    
  }

}



// WEBPACK FOOTER //
// ./src/components/single-post/single-post.ts